/**
 * sections.js
 *
 * Import the JS for your sections here.
 *
 */
import ComponentInit from '../js/utils/ComponentInit';
// import './FilteredListing/FilteredListing';
// import './AlgoliaSearch/AlgoliaSearch';
import './HomepageBanner/HomepageBanner';
import './CardCarousel/CardCarousel';
import TestimonialSlider from './TestimonialSlider/TestimonialSlider';
import MobileNav from './MobileHeader/MobileNav';
import './MobileHeader/MobileHeader';
import './LargeLinks/LargeLinks';
import './ServicesCarousel/ServicesCarousel';
import './ImageCarousel/ImageCarousel';
import './ProjectListing/ProjectListing';

// // Format:
// // data-component-name: ComponentFunction
// // we shall order these in page load critical first
const componentList = { TestimonialSlider, MobileNav };

export default ComponentInit(componentList);
